import { useId } from "react";
import type { ReactNode } from "react";

/**
 * 선택 버튼 묶음(라디오) — 이름표 + 와이어 '.opt' 버튼 줄. role=radiogroup 에 이름표를 잇는다(fieldset·legend 는 flex 줄에 서지 않아서).
 * 안의 <label className="pf-seg__opt"><input type="radio"/>…</label> 은 같은 name 을 쓴다(방향키로 옮겨 다님).
 */
export function SegGroup({
  label,
  hideLabel = false,
  variant,
  testId,
  invalid,
  children,
}: {
  label: string;
  hideLabel?: boolean;
  variant?: "pill" | "green";
  testId?: string;
  invalid?: boolean;
  children: ReactNode;
}) {
  const id = useId();
  return (
    <div
      className="pf-field-row"
      role="radiogroup"
      aria-labelledby={id}
      aria-invalid={invalid || undefined}
      data-testid={testId}
    >
      <span id={id} className={hideLabel ? "pf-sr-only" : "pf-field-label"}>
        {label}
      </span>
      <div className={`pf-seg${variant ? ` pf-seg--${variant}` : ""}`}>{children}</div>
    </div>
  );
}
